/**
 * Analytics seam for `@naumu/ui`.
 *
 * The design-system package must not import the app's analytics client (it
 * would drag PostHog and the app's provider tree into every consumer), but a
 * handful of DS components do emit product events. They call {@link uiTrack},
 * which is a no-op until the host app registers a tracker with
 * {@link setUiTracker}. `apps/web` registers it from `AnalyticsProvider`,
 * so behaviour matches the previous `getClientAnalytics().track(...)` calls.
 */
export type UiTrackFn = (
	event: string,
	properties?: Record<string, unknown>,
) => void;

let registeredTracker: UiTrackFn = () => {};

export const setUiTracker = (tracker: UiTrackFn): void => {
	registeredTracker = tracker;
};

export const uiTrack: UiTrackFn = (event, properties) => {
	registeredTracker(event, properties);
};
